<template>
  <b-card
    no-body
    class="rounded-10 px-3 pb-0"
  >
    <b-row>
      <b-col
        :md="asideLeftWidth"
        class="bg-light rounded-10-left-top"
      >
      </b-col>
      <b-col class="py-3"
             xs="12">
        <div class="d-flex flex-row px-1">
          <h5 class="text-uppercase text-dark font-weight-normal mb-0">{{title}}</h5>
          <slot name="titleButton"></slot>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :md="asideLeftWidth"
        xs="12"
        class="bg-light rounded-10-left-bottom pt-3"
      >
        <slot name="asideLeft"/>
      </b-col>
      <b-col xs="12" class="pb-5 px-3 pt-3">
        <b-row class="align-items-center h-100">
          <b-col>
            <slot name="body"/>
          </b-col>
        </b-row>
        <slot name="body-footer"/>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      },
      asideLeftWidth: {
        type: Number,
        default: 3
      }
    }
  }
</script>